module.exports = require("core-js-pure/features/get-iterator-method");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js
// module id = 253
// module chunks = 0 1